import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "details-content" }
const _hoisted_2 = {
  key: 0,
  class: "game-name-heading"
}
const _hoisted_3 = { class: "transaction-header-bar" }
const _hoisted_4 = { class: "header-info-list" }
const _hoisted_5 = { class: "info-row" }
const _hoisted_6 = { class: "info-label" }
const _hoisted_7 = { class: "info-value info-value-copy" }
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = { class: "info-row" }
const _hoisted_10 = { class: "info-label" }
const _hoisted_11 = { class: "info-value" }
const _hoisted_12 = { class: "info-row" }
const _hoisted_13 = { class: "info-label" }
const _hoisted_14 = { class: "info-value info-value-copy reference-wrap" }
const _hoisted_15 = ["aria-label"]
const _hoisted_16 = { class: "info-row" }
const _hoisted_17 = { class: "info-label" }
const _hoisted_18 = { class: "info-value" }
const _hoisted_19 = { class: "info-row" }
const _hoisted_20 = { class: "info-label" }
const _hoisted_21 = { class: "info-value" }
const _hoisted_22 = { class: "info-row" }
const _hoisted_23 = { class: "info-label" }
const _hoisted_24 = { class: "info-value font-bold" }
const _hoisted_25 = { class: "info-row" }
const _hoisted_26 = { class: "info-label" }
const _hoisted_27 = { class: "info-value font-bold" }
const _hoisted_28 = { class: "info-row" }
const _hoisted_29 = { class: "info-label" }
const _hoisted_30 = {
  key: 1,
  class: "draws-section"
}
const _hoisted_31 = { class: "draws-section-title" }
const _hoisted_32 = { class: "draw-header-bar" }
const _hoisted_33 = { class: "draw-header-main" }
const _hoisted_34 = { class: "draw-index-badge" }
const _hoisted_35 = { class: "game-draw-title" }
const _hoisted_36 = {
  key: 0,
  class: "event-cancelled-badge"
}
const _hoisted_37 = { class: "draw-summary-rows" }
const _hoisted_38 = { class: "summary-row-item" }
const _hoisted_39 = { class: "summary-label" }
const _hoisted_40 = { class: "summary-value" }
const _hoisted_41 = { class: "summary-row-item" }
const _hoisted_42 = { class: "summary-label" }
const _hoisted_43 = { class: "summary-value" }
const _hoisted_44 = {
  key: 0,
  class: "results-numbers-inline"
}
const _hoisted_45 = {
  key: 1,
  class: "no-results-text"
}
const _hoisted_46 = {
  key: 2,
  class: "no-results-text"
}
const _hoisted_47 = { class: "summary-row-item" }
const _hoisted_48 = { class: "summary-label" }
const _hoisted_49 = { class: "summary-value font-bold" }
const _hoisted_50 = { class: "summary-row-item" }
const _hoisted_51 = { class: "summary-label" }
const _hoisted_52 = { class: "summary-value font-bold" }
const _hoisted_53 = ["aria-expanded", "onClick"]
const _hoisted_54 = { class: "summary-label bets-accordion-label" }
const _hoisted_55 = { class: "bets-table-container" }
const _hoisted_56 = { class: "desktop-only" }
const _hoisted_57 = { class: "bets-data-table" }
const _hoisted_58 = { class: "bet-group-label-row" }
const _hoisted_59 = {
  colspan: "8",
  class: "bet-group-label-cell"
}
const _hoisted_60 = { class: "bet-id-cell" }
const _hoisted_61 = { class: "draw-index-badge bet-letter-badge" }
const _hoisted_62 = { class: "bet-id-text" }
const _hoisted_63 = { class: "bet-group-header-row" }
const _hoisted_64 = { class: "col-text" }
const _hoisted_65 = { class: "col-text col-your-bet" }
const _hoisted_66 = { class: "col-text" }
const _hoisted_67 = { class: "col-numeric" }
const _hoisted_68 = { class: "col-numeric" }
const _hoisted_69 = { class: "col-numeric" }
const _hoisted_70 = { class: "col-numeric" }
const _hoisted_71 = { class: "col-status" }
const _hoisted_72 = { class: "bet-group-data-row" }
const _hoisted_73 = { class: "col-text font-bold" }
const _hoisted_74 = { class: "col-text col-your-bet" }
const _hoisted_75 = { class: "bet-details-info" }
const _hoisted_76 = { class: "market-name-label" }
const _hoisted_77 = {
  key: 0,
  class: "market-text-label"
}
const _hoisted_78 = {
  key: 0,
  class: "selected-numbers-row"
}
const _hoisted_79 = { class: "col-text" }
const _hoisted_80 = { class: "col-numeric" }
const _hoisted_81 = { class: "col-numeric" }
const _hoisted_82 = { class: "col-numeric" }
const _hoisted_83 = { class: "col-numeric" }
const _hoisted_84 = { class: "col-status" }
const _hoisted_85 = { class: "mobile-only" }
const _hoisted_86 = { class: "bet-card-header" }
const _hoisted_87 = { class: "bet-id-cell" }
const _hoisted_88 = { class: "draw-index-badge bet-letter-badge" }
const _hoisted_89 = { class: "bet-id-text" }
const _hoisted_90 = { class: "bet-row-item" }
const _hoisted_91 = { class: "label" }
const _hoisted_92 = { class: "value bet-outcome-value" }
const _hoisted_93 = { class: "market-name-label" }
const _hoisted_94 = {
  key: 0,
  class: "market-text-label"
}
const _hoisted_95 = {
  key: 1,
  class: "selected-numbers-row"
}
const _hoisted_96 = { class: "bet-row-item" }
const _hoisted_97 = { class: "label" }
const _hoisted_98 = { class: "value" }
const _hoisted_99 = { class: "bet-row-item" }
const _hoisted_100 = { class: "label" }
const _hoisted_101 = { class: "value" }
const _hoisted_102 = { class: "bet-row-item" }
const _hoisted_103 = { class: "label" }
const _hoisted_104 = { class: "value" }
const _hoisted_105 = { class: "bet-row-item" }
const _hoisted_106 = { class: "label" }
const _hoisted_107 = { class: "value" }
const _hoisted_108 = { class: "bet-row-item" }
const _hoisted_109 = { class: "label" }
const _hoisted_110 = { class: "value" }
const _hoisted_111 = { class: "details-footer" }
const _hoisted_112 = ["disabled", "aria-busy"]

import { computed, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import type { Game, TransactionDetail } from "@/stores/transactions";
import { formatCurrency } from "@/utils/currency";
import { useTheme } from "@/composables/useTheme";
import { useToast } from "@/composables/useToast";
import { copyTextToClipboard } from "@/utils/copyToClipboard";


const __default__ = {
  name: 'TransactionDetails',
}

type FlatDraw = { gameKey: string; game: Game; drawIndex: number };


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    transaction: {},
    isRebetting: { type: Boolean }
  },
  emits: ["rebet", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { t } = useI18n();
const { showToast } = useToast();
const { currentThemeName } = useTheme();
const useWonLostLabels = computed(() => currentThemeName.value === 'wsb');

const flattenedDraws = computed((): FlatDraw[] => {
  const list: FlatDraw[] = [];
  let index = 1;
  for (const gameKey in props.transaction.games) {
    const games = props.transaction.games[gameKey] || [];
    for (const game of games) {
      list.push({ gameKey, game, drawIndex: index++ });
    }
  }
  return list;
});

const drawCount = computed(() => flattenedDraws.value.length);

const primaryGameName = computed(() => {
  const names = new Set(flattenedDraws.value.map((entry) => entry.game.name));
  if (names.size === 1) {
    return [...names][0];
  }
  return flattenedDraws.value[0]?.game.name ?? '';
});

const expandedDraws = ref<Record<string, boolean>>({});

const drawKey = (gameKey: string, game: Game) => `${gameKey}-${game.draw_id}`;

watch(
  flattenedDraws,
  (list) => {
    list.forEach((entry, idx) => {
      const key = drawKey(entry.gameKey, entry.game);
      if (!(key in expandedDraws.value)) {
        expandedDraws.value[key] = false;
      }
    });
  },
  { immediate: true },
);

const isDrawExpanded = (entry: FlatDraw) =>
  expandedDraws.value[drawKey(entry.gameKey, entry.game)] ?? false;

const toggleDrawExpanded = (entry: FlatDraw) => {
  const key = drawKey(entry.gameKey, entry.game);
  expandedDraws.value[key] = !expandedDraws.value[key];
};

const betLetterLabel = (index: number): string => {
  if (index < 0) return 'A';
  if (index < 26) return String.fromCharCode(65 + index);
  return String(index + 1);
};

const formatStatusLabel = (status: string, winnings: number | string = 0) => {
  if (!useWonLostLabels.value || String(status).toLowerCase() !== 'settled') {
    return status;
  }
  return parseFloat(String(winnings || 0)) > 0 ? t('wagers.won') : t('wagers.lost');
};

const formatStatusClass = (status: string, winnings: number | string = 0) => {
  if (!useWonLostLabels.value || String(status).toLowerCase() !== 'settled') {
    return String(status).toLowerCase();
  }
  return parseFloat(String(winnings || 0)) > 0 ? 'won' : 'lost';
};

const hasBetNumbers = (bet: any) => {
  if (!Array.isArray(bet?.bet_numbers)) return false;
  return bet.bet_numbers.some((group: any) => Array.isArray(group) && group.length > 0);
};

const emit = __emit;

const isTransactionSettled = computed(() => {
  for (const gameKey in props.transaction.games) {
    const games = props.transaction.games[gameKey];
    for (const game of games) {
      for (const bet of game.bets) {
        const betStatus = getBetStatus(bet, game);
        if (betStatus !== 'Settled') {
          return false;
        }
      }
    }
  }
  return true;
});

const getTransactionStatus = () => {
  for (const gameKey in props.transaction.games) {
    const games = props.transaction.games[gameKey];
    for (const game of games) {
      if (game.event_cancelled === 'yes') {
        return 'Cancelled';
      }
      for (const bet of game.bets) {
        const betStatus = getBetStatus(bet, game);
        if (betStatus === 'Cancelled') {
          return 'Cancelled';
        }
        if (betStatus !== 'Settled') {
          return 'Open';
        }
      }
    }
  }
  return 'Settled';
};

const getDrawStatus = (game: Game) => {
  if (game.event_cancelled === 'yes') {
    return 'Cancelled';
  }
  for (const bet of game.bets) {
    const betStatus = getBetStatus(bet, game);
    if (betStatus === 'Cancelled') {
      return 'Cancelled';
    }
    if (betStatus !== 'Settled') {
      return 'Open';
    }
  }
  return 'Settled';
};

const handleRebet = () => {
  emit('rebet');
};

const MONTHS_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const formatHeaderDate = (dateString: string) => {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = MONTHS_SHORT[date.getMonth()];
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');
  return `${day} ${month} ${year}, ${hours}:${minutes}:${seconds}`;
};

const formatDrawDate = (dateString: string) => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');
  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};

const copyToClipboard = async (text: string) => {
  const copied = await copyTextToClipboard(text);
  if (copied) {
    showToast({
      title: t("transactionDetails.textCopied"),
      message: "",
      type: "success",
      duration: 2500,
      centered: true,
    });
    return;
  }
  showToast({
    title: t("common.error"),
    message: t("transactionDetails.copyFailed"),
    type: "error",
    duration: 4000,
    centered: true,
  });
};

const parseAmount = (value: string | number | null | undefined): number => {
  if (value === null || value === undefined || value === '') {
    return 0;
  }
  const parsed = typeof value === 'number' ? value : parseFloat(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const getGameTotalBetCost = (game: Game): number =>
  game.bets.reduce((sum, bet) => sum + parseAmount(bet.bet_cost), 0);

const getGameTotalWinnings = (game: Game): number =>
  game.bets.reduce((sum, bet) => sum + parseAmount(bet.winnings), 0);

const isGameSettled = (game: Game): boolean => {
  if (game.event_cancelled === 'yes') {
    return true;
  }
  return game.bets.every((bet) => {
    const status = getBetStatus(bet, game);
    return status === 'Settled' || status === 'Cancelled';
  });
};

const formatSlipTotalReturn = () => {
  const status = getTransactionStatus();
  if (status === 'Open') {
    const winnings = parseAmount(props.transaction.transaction.total_winnings);
    if (winnings > 0) {
      return formatCurrency(winnings, props.transaction.transaction.currency_symbol);
    }
    return t('wagers.tbc');
  }
  return formatCurrency(
    props.transaction.transaction.total_winnings,
    props.transaction.transaction.currency_symbol,
  );
};

const formatDrawTotalBet = (game: Game) => {
  if (!isGameSettled(game)) {
    return t('wagers.tbc');
  }
  return formatCurrency(getGameTotalBetCost(game), props.transaction.transaction.currency_symbol);
};

const formatDrawTotalReturn = (game: Game) => {
  if (!isGameSettled(game)) {
    return t('wagers.tbc');
  }
  return formatCurrency(getGameTotalWinnings(game), props.transaction.transaction.currency_symbol);
};

const isBetOpen = (bet: any, game: Game) => {
  const status = getBetStatus(bet, game);
  return status === 'Open';
};

const formatPotentialReturns = (bet: any, game: Game) => {
  if (getBetStatus(bet, game) === 'Cancelled') {
    return formatCurrency(0, props.transaction.transaction.currency_symbol);
  }
  if (isBetOpen(bet, game)) {
    return t('wagers.tbc');
  }
  return formatCurrency(bet.bet_cost * bet.odds, props.transaction.transaction.currency_symbol);
};

const formatActualReturns = (bet: any, game: Game) => {
  if (getBetStatus(bet, game) === 'Cancelled') {
    return formatCurrency(0, props.transaction.transaction.currency_symbol);
  }
  if (isBetOpen(bet, game)) {
    return t('wagers.tbc');
  }
  return bet.winnings
    ? formatCurrency(bet.winnings, props.transaction.transaction.currency_symbol)
    : formatCurrency(0, props.transaction.transaction.currency_symbol);
};

const getBetStatus = (bet: any, game: any) => {
  if (game.event_cancelled === "yes") {
    return "Cancelled";
  }
  if (bet.cancelled === true) {
    return "Cancelled";
  }
  return bet.status;
};

const getWinningNumbers = (game: any) => {
  if (game?.results && Array.isArray(game.results) && game.results.length > 0) {
    return game.results.flat();
  }
  return [];
};

const isWinningBonusNumber = (index: number, game: any) => {
  if (game?.results && Array.isArray(game.results) && game.results.length > 1) {
    const mainNumbers = game.results[0] || [];
    return index >= mainNumbers.length;
  }
  return false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (primaryGameName.value)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(primaryGameName.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('wagers.transId')) + ":", 1),
          _createElementVNode("span", _hoisted_7, [
            _createTextVNode(_toDisplayString(_ctx.transaction.transaction.transaction_id) + " ", 1),
            _createElementVNode("button", {
              type: "button",
              class: "copy-button",
              "aria-label": _ctx.$t('transactionDetails.copyToClipboard'),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (copyToClipboard(String(_ctx.transaction.transaction.transaction_id))))
            }, _cache[2] || (_cache[2] = [
              _createElementVNode("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                "aria-hidden": "true"
              }, [
                _createElementVNode("rect", {
                  x: "5",
                  y: "5",
                  width: "9",
                  height: "9",
                  rx: "1",
                  stroke: "currentColor",
                  "stroke-width": "1.25"
                }),
                _createElementVNode("path", {
                  d: "M4 11H3C2.44772 11 2 10.5523 2 10V3C2 2.44772 2.44772 2 3 2H10C10.5523 2 11 2.44772 11 3V4",
                  stroke: "currentColor",
                  "stroke-width": "1.25"
                })
              ], -1)
            ]), 8, _hoisted_8)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('wagers.date')) + ":", 1),
          _createElementVNode("span", _hoisted_11, _toDisplayString(formatHeaderDate(_ctx.transaction.transaction.date)), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('wagers.reference')) + ":", 1),
          _createElementVNode("span", _hoisted_14, [
            _createTextVNode(_toDisplayString(_ctx.transaction.transaction.reference) + " ", 1),
            _createElementVNode("button", {
              type: "button",
              class: "copy-button",
              "aria-label": _ctx.$t('transactionDetails.copyToClipboard'),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (copyToClipboard(_ctx.transaction.transaction.reference)))
            }, _cache[3] || (_cache[3] = [
              _createElementVNode("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                "aria-hidden": "true"
              }, [
                _createElementVNode("rect", {
                  x: "5",
                  y: "5",
                  width: "9",
                  height: "9",
                  rx: "1",
                  stroke: "currentColor",
                  "stroke-width": "1.25"
                }),
                _createElementVNode("path", {
                  d: "M4 11H3C2.44772 11 2 10.5523 2 10V3C2 2.44772 2.44772 2 3 2H10C10.5523 2 11 2.44772 11 3V4",
                  stroke: "currentColor",
                  "stroke-width": "1.25"
                })
              ], -1)
            ]), 8, _hoisted_15)
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('wagers.description')) + ":", 1),
          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('wagers.wager')), 1)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('wagers.drawsPlayed')) + ":", 1),
          _createElementVNode("span", _hoisted_21, _toDisplayString(drawCount.value), 1)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('wagers.totalBetAmount')) + ":", 1),
          _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(formatCurrency)(_ctx.transaction.transaction.total_cost, _ctx.transaction.transaction.currency_symbol)), 1)
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('wagers.totalReturn')) + ":", 1),
          _createElementVNode("span", _hoisted_27, _toDisplayString(formatSlipTotalReturn()), 1)
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('wagers.status')) + ":", 1),
          _createElementVNode("span", {
            class: _normalizeClass(['info-value', 'status-text', formatStatusClass(getTransactionStatus(), _ctx.transaction.transaction.total_winnings)])
          }, _toDisplayString(formatStatusLabel(getTransactionStatus(), _ctx.transaction.transaction.total_winnings)), 3)
        ])
      ])
    ]),
    (drawCount.value > 0)
      ? (_openBlock(), _createElementBlock("section", _hoisted_30, [
          _createElementVNode("h3", _hoisted_31, _toDisplayString(_ctx.$t('transactionDetails.drawsSection', { count: drawCount.value })), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(flattenedDraws.value, (entry) => {
            return (_openBlock(), _createElementBlock("div", {
              key: drawKey(entry.gameKey, entry.game),
              class: "game-draw-section"
            }, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("span", _hoisted_34, _toDisplayString(entry.drawIndex), 1),
                  _createElementVNode("span", _hoisted_35, [
                    _createTextVNode(_toDisplayString(entry.game.name) + " - " + _toDisplayString(formatDrawDate(entry.game.draw_date)) + " ", 1),
                    (entry.game.event_cancelled === 'yes')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_36, "CANCELLED"))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("span", {
                  class: _normalizeClass(['draw-status-text', formatStatusClass(getDrawStatus(entry.game), getGameTotalWinnings(entry.game))])
                }, _toDisplayString(formatStatusLabel(getDrawStatus(entry.game), getGameTotalWinnings(entry.game))), 3)
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t('transactionDetails.drawId')) + ":", 1),
                  _createElementVNode("span", _hoisted_40, _toDisplayString(entry.game.event_id || entry.game.draw_id), 1)
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.$t('transactionDetails.results')) + ":", 1),
                  _createElementVNode("span", _hoisted_43, [
                    (getWinningNumbers(entry.game).length > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_44, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getWinningNumbers(entry.game), (number, index) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: index,
                              class: _normalizeClass(['number-ball-item', { 'bonus': isWinningBonusNumber(index, entry.game) }])
                            }, _toDisplayString(number), 3))
                          }), 128))
                        ]))
                      : (entry.game.has_results && isTransactionSettled.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(_ctx.$t('wagers.pendingResults')), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(_ctx.$t('wagers.tbc')), 1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.$t('wagers.totalBet')) + ":", 1),
                  _createElementVNode("span", _hoisted_49, _toDisplayString(formatDrawTotalBet(entry.game)), 1)
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.$t('wagers.totalReturn')) + ":", 1),
                  _createElementVNode("span", _hoisted_52, _toDisplayString(formatDrawTotalReturn(entry.game)), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "summary-row-item bets-accordion-trigger",
                  "aria-expanded": isDrawExpanded(entry),
                  onClick: ($event: any) => (toggleDrawExpanded(entry))
                }, [
                  _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.$t('transactionDetails.yourBetsInDraw', { count: entry.game.bets.length })), 1),
                  (_openBlock(), _createElementBlock("svg", {
                    class: _normalizeClass(["accordion-chevron", { 'accordion-chevron--expanded': isDrawExpanded(entry) }]),
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    "aria-hidden": "true"
                  }, _cache[4] || (_cache[4] = [
                    _createElementVNode("path", {
                      d: "M4 6L8 10L12 6",
                      stroke: "currentColor",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, -1)
                  ]), 2))
                ], 8, _hoisted_53)
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("table", _hoisted_57, [
                    _cache[5] || (_cache[5] = _createElementVNode("colgroup", null, [
                      _createElementVNode("col", { class: "col-bet-id" }),
                      _createElementVNode("col", { class: "col-your-bet" }),
                      _createElementVNode("col", { class: "col-bet-type" }),
                      _createElementVNode("col", { class: "col-odds" }),
                      _createElementVNode("col", { class: "col-bet-amount" }),
                      _createElementVNode("col", { class: "col-potential" }),
                      _createElementVNode("col", { class: "col-actual" }),
                      _createElementVNode("col", { class: "col-status" })
                    ], -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.game.bets, (bet, betIndex) => {
                      return (_openBlock(), _createElementBlock("tbody", {
                        key: `${bet.bet_id}-${betIndex}`,
                        class: "bet-group"
                      }, [
                        _createElementVNode("tr", _hoisted_58, [
                          _createElementVNode("td", _hoisted_59, [
                            _createElementVNode("div", _hoisted_60, [
                              _createElementVNode("span", _hoisted_61, _toDisplayString(betLetterLabel(betIndex)), 1),
                              _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.$t('transactionDetails.betId')) + ":" + _toDisplayString(bet.bet_id), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("tr", _hoisted_63, [
                          _createElementVNode("th", _hoisted_64, _toDisplayString(_ctx.$t('transactionDetails.betId')), 1),
                          _createElementVNode("th", _hoisted_65, _toDisplayString(_ctx.$t('transactionDetails.yourBet')), 1),
                          _createElementVNode("th", _hoisted_66, _toDisplayString(_ctx.$t('transactionDetails.betType')), 1),
                          _createElementVNode("th", _hoisted_67, _toDisplayString(_ctx.$t('transactionDetails.odds')), 1),
                          _createElementVNode("th", _hoisted_68, _toDisplayString(_ctx.$t('transactionDetails.betAmount')), 1),
                          _createElementVNode("th", _hoisted_69, _toDisplayString(_ctx.$t('transactionDetails.potentialReturns')), 1),
                          _createElementVNode("th", _hoisted_70, _toDisplayString(_ctx.$t('transactionDetails.actualReturns')), 1),
                          _createElementVNode("th", _hoisted_71, _toDisplayString(_ctx.$t('wagers.status')), 1)
                        ]),
                        _createElementVNode("tr", _hoisted_72, [
                          _createElementVNode("td", _hoisted_73, _toDisplayString(bet.bet_id), 1),
                          _createElementVNode("td", _hoisted_74, [
                            _createElementVNode("div", _hoisted_75, [
                              _createElementVNode("span", _hoisted_76, _toDisplayString(bet.market_name), 1),
                              (bet.market_text)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_77, _toDisplayString(bet.market_text), 1))
                                : _createCommentVNode("", true)
                            ]),
                            (hasBetNumbers(bet))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bet.bet_numbers, (numbers, index) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                                      (numbers.length > 0)
                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(numbers, (number) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                              key: `${index}-${number}`,
                                              class: _normalizeClass(['number-ball-small', { 'bonus': index === 1 }])
                                            }, _toDisplayString(number), 3))
                                          }), 128))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  }), 256))
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_79, _toDisplayString(bet.betType), 1),
                          _createElementVNode("td", _hoisted_80, _toDisplayString(bet.odds), 1),
                          _createElementVNode("td", _hoisted_81, _toDisplayString(_unref(formatCurrency)(bet.bet_cost, _ctx.transaction.transaction.currency_symbol)), 1),
                          _createElementVNode("td", _hoisted_82, _toDisplayString(formatPotentialReturns(bet, entry.game)), 1),
                          _createElementVNode("td", _hoisted_83, _toDisplayString(formatActualReturns(bet, entry.game)), 1),
                          _createElementVNode("td", _hoisted_84, [
                            _createElementVNode("span", {
                              class: _normalizeClass(['bet-status-label', formatStatusClass(getBetStatus(bet, entry.game), bet.winnings)])
                            }, _toDisplayString(formatStatusLabel(getBetStatus(bet, entry.game), bet.winnings)), 3)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_85, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.game.bets, (bet, betIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `${bet.bet_id}-${betIndex}`,
                      class: "bet-item-card-mobile"
                    }, [
                      _createElementVNode("div", _hoisted_86, [
                        _createElementVNode("div", _hoisted_87, [
                          _createElementVNode("span", _hoisted_88, _toDisplayString(betLetterLabel(betIndex)), 1),
                          _createElementVNode("span", _hoisted_89, _toDisplayString(_ctx.$t('transactionDetails.betId')) + ":" + _toDisplayString(bet.bet_id), 1)
                        ]),
                        _createElementVNode("span", {
                          class: _normalizeClass(['bet-card-status', formatStatusClass(getBetStatus(bet, entry.game), bet.winnings)])
                        }, _toDisplayString(formatStatusLabel(getBetStatus(bet, entry.game), bet.winnings)), 3)
                      ]),
                      _createElementVNode("div", _hoisted_90, [
                        _createElementVNode("span", _hoisted_91, _toDisplayString(_ctx.$t('transactionDetails.yourBet')) + ":", 1),
                        _createElementVNode("span", _hoisted_92, [
                          _createElementVNode("span", _hoisted_93, _toDisplayString(bet.market_name), 1),
                          (bet.market_text)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_94, _toDisplayString(bet.market_text), 1))
                            : _createCommentVNode("", true),
                          (hasBetNumbers(bet))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_95, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bet.bet_numbers, (numbers, index) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                                    (numbers.length > 0)
                                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(numbers, (number) => {
                                          return (_openBlock(), _createElementBlock("span", {
                                            key: `${bet.bet_id}-${index}-${number}`,
                                            class: _normalizeClass(['number-ball-small', { 'bonus': index === 1 }])
                                          }, _toDisplayString(number), 3))
                                        }), 128))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                }), 256))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_96, [
                        _createElementVNode("span", _hoisted_97, _toDisplayString(_ctx.$t('transactionDetails.betType')) + ":", 1),
                        _createElementVNode("span", _hoisted_98, _toDisplayString(bet.betType), 1)
                      ]),
                      _createElementVNode("div", _hoisted_99, [
                        _createElementVNode("span", _hoisted_100, _toDisplayString(_ctx.$t('transactionDetails.odds')) + ":", 1),
                        _createElementVNode("span", _hoisted_101, _toDisplayString(bet.odds), 1)
                      ]),
                      _createElementVNode("div", _hoisted_102, [
                        _createElementVNode("span", _hoisted_103, _toDisplayString(_ctx.$t('transactionDetails.betAmount')) + ":", 1),
                        _createElementVNode("span", _hoisted_104, _toDisplayString(_unref(formatCurrency)(bet.bet_cost, _ctx.transaction.transaction.currency_symbol)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_105, [
                        _createElementVNode("span", _hoisted_106, _toDisplayString(_ctx.$t('transactionDetails.potentialReturns')) + ":", 1),
                        _createElementVNode("span", _hoisted_107, _toDisplayString(formatPotentialReturns(bet, entry.game)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_108, [
                        _createElementVNode("span", _hoisted_109, _toDisplayString(_ctx.$t('transactionDetails.actualReturns')) + ":", 1),
                        _createElementVNode("span", _hoisted_110, _toDisplayString(formatActualReturns(bet, entry.game)), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ], 512), [
                [_vShow, isDrawExpanded(entry)]
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_111, [
      _createElementVNode("button", {
        class: "footer-rebet-button",
        disabled: _ctx.isRebetting,
        "aria-busy": _ctx.isRebetting,
        onClick: handleRebet
      }, _toDisplayString(_ctx.$t('wagers.rebet')), 9, _hoisted_112)
    ])
  ]))
}
}

})